import { render, staticRenderFns } from "./AsterList.vue?vue&type=template&id=1af8cd70&"
import script from "./AsterList.vue?vue&type=script&lang=js&"
export * from "./AsterList.vue?vue&type=script&lang=js&"
import style0 from "./AsterList.vue?vue&type=style&index=0&id=1af8cd70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports